//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../modalSchedulingFormModule.scss'

const uuid = require('react-uuid')

// @ADD Component types
interface IModalSchedulingFormModuleLayoutProps {
  open          : boolean
  processing    : boolean
  customErrors? : any
  editData?     : any
  handleClose   : (data:any)=>void
  onHandleSubmit: (data: any) => void
}

const ModalSchedulingFormModuleLayout: React.FC<IModalSchedulingFormModuleLayoutProps> = (props) => {

  const [colors] = useColors()

  const {open} = props

  const formHook = useForm()
  const { t } = useTranslation()

  const handleCloseModal = (data: any) => {
    props.handleClose(data)
  }

  return(
    <div className=''>
      <Modal show={open} onHide={() => handleCloseModal({ status: false })} className="modal_scheduling_form-module">
        <Modal.Header>
          <Modal.Title>
            {t('modules.modal_scheduling_form.title')}
          </Modal.Title>
          <div className="close-button" onClick={() => handleCloseModal({status: false})}>
            <IconComponent
              color={colors.secondary}
              width='1.5rem'
              height='1.5rem'
              fontawesome={{
                icon: 'fas fa-times-circle',
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>
            <input
              type="hidden"
              name="unique"
              defaultValue={(props?.editData?.unique) ? props?.editData?.unique : uuid()}
              ref={formHook.register({ required: true })}
            />
            <div className="col-12">
              <div className="form-group">
                <label htmlFor='title'>{t('labels.modal_scheduling_form.title')}</label>
                {formHook.errors.title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='title'
                  name='title'
                  className={`form-control ${formHook.errors.title && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.title}
                />
              </div>
            </div>
            <div className="col-12">
              <div className='form-group'>
                <label htmlFor='attached'>{t('labels.modal_scheduling_form.attached')}</label>
                {formHook.errors?.attached && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='attached'
                  name='attached'
                  className='form-control-file'
                  type='file'
                  ref={formHook.register({ required: false })}
                />
                {formHook.errors?.attached && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            {props?.editData?.attachedFile && (
              <>
                <input type="hidden" name="attachedUrl" value={props?.editData?.attachedUrl} ref={formHook.register({ required: true })} />
                <div className="col-md-12">
                  <div className="form-group">
                      <div className="cover-container">
                        <img src={props?.editData?.attachedFile} alt=""/>
                      </div>
                  </div>
                </div>
              </>
            )}
            <div className='buttons-group'>
              <div className='text-center'>
                <button className='btn btn-secondary' type='submit' disabled={props.processing}>
                  {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                  {t('modules.modal_scheduling_form.form.save')}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ModalSchedulingFormModuleLayout
